import React, { useState } from 'react';

async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * 週活動／主辦送審共用圖片上傳（base64 → /api/weekly-activity/upload-image）
 */
export default function WeeklyActivityImageUpload({
  onUploaded,
  onError,
  adminAuthHeaders,
  disabled = false,
  multiple = true,
  accept = 'image/*',
  inputStyle,
  label = '上傳圖片',
}) {
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const urls = [];
      for (const file of files) {
        const base64 = await fileToBase64(file);
        const res = await fetch('/api/weekly-activity/upload-image', {
          method: 'POST',
          headers: { ...adminAuthHeaders(), 'Content-Type': 'application/json' },
          body: JSON.stringify({ file: base64 }),
        });
        const data = await res.json();
        if (!data?.success || !data?.imageUrl) throw new Error(data?.error || '上傳失敗');
        urls.push(data.imageUrl);
      }
      if (urls.length && onUploaded) onUploaded(urls);
    } catch (err) {
      if (onError) onError(err);
      else window.alert(err.message || '上傳失敗');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <label style={{ display: 'inline-block', cursor: disabled || uploading ? 'not-allowed' : 'pointer', ...inputStyle }}>
      <input
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled || uploading}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      {uploading ? '上傳中…' : label}
    </label>
  );
}
